<template>
  <step-block
    class="step-block--innovation"
    v-bind="$attrs"
    v-on="$listeners"
    :cover-image="photo"
    :title-image="icon"
    :description="description"
    :description-expandable="true"
  >
    <div slot="afterDescription">
      <ul class="list" v-if="attributes && attributes.length > 0">
        <li
          v-for="(attribute, index) in attributes"
          :key="`${attribute.name}-${index}`"
        >
          <span :data-tooltip="attribute.name" data-placement="top">
            <img class="img-fluid" :src="attribute.photo">
          </span>
        </li>
      </ul>
    </div>
  </step-block>
</template>

<script>
  export default {
    name: 'InnovationBlock',
    props: {
      id: {},
      name: String,
      description: String,
      icon: String,
      photo: String,
      attributes: Array,
    },
  };
</script>
